
import { RestrictionsSettingsContent } from "./RestrictionsSettingsContent";

export const RestrictionsSection = () => {
  return (
    <div className="h-full w-full">
      <RestrictionsSettingsContent />
    </div>
  );
};
